import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptCodeDatasourceService } from '../receipt-code-datasource.service';
import { PERMISSION } from 'src/app/const/permission';
import { ReceiptCodeGridComponent } from '../receipt-code-grid/receipt-code-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { ScreenService } from 'src/app/common/services/screen.service';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { HasAnyPermissionDirective } from 'src/app/common/directives/has-any-permission/has-any-permission.directive';

@Component({
  selector: 'app-receipt-code-search',
  templateUrl: './receipt-code-search.component.html',
  styleUrls: ['./receipt-code-search.component.scss'],
  imports: [
    ReceiptCodeGridComponent,
    MatMenuModule,
    MatIconModule,
    CommonModule,
    PageContainerComponent,
    ButtonComponent,
    BreadcrumbsComponent,
    HasAnyPermissionDirective
  ]
})
export class ReceiptCodeSearchComponent {
  private router = inject(Router);
  private datasource = inject(ReceiptCodeDatasourceService);
  private cdRef = inject(ChangeDetectorRef);
  screen = inject(ScreenService);
  appVersion = inject(AppVersionService);

  readonly title = 'Search receipt codes';

  isLoading = false;
  readonly permissions = PERMISSION;

  get total(): number {
    return this.datasource.total;
  }

  // Make loading state more stable
  get loading(): boolean {
    return this.screen.isLoading();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  generateSample() {
    this.router.navigate(['/receipt-codes/generate-sample']);
  }
}
